import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import ProductHelper, { TitleOption } from 'src/app/helpers/product-helper';
import { BoardTypeChoices } from 'src/app/model/product/board/board-part';
import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'ip-board-collaborative-title-picker',
  templateUrl: './ip-board-collaborative-title-picker.component.html',
  styleUrls: ['./ip-board-collaborative-title-picker.component.scss'],
})
export class IPBoardCollaborativeTitlePickerComponent
  extends SubscriptionBasedComponent
  implements OnInit, OnDestroy
{
  @Input()
  ipBoardPart: IPBoardPart;
  @Input()
  leftRightBoard = false;
  @Input()
  label = 'Links';
  @Output()
  save = new EventEmitter<any>();

  TITLE_OPTIONS = ProductHelper.TITLE_OPTIONS;
  OTHER_TITLE_ID = ProductHelper.OTHER_TITLE_ID;

  selectedTitleOption: TitleOption;
  selectedOtherSideTitleOption: TitleOption;

  BOARD_TYPE_CHOICES = BoardTypeChoices;

  showOtherSidePicker: boolean = false;

  private emitValueChanged = new Subject<any>();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.ipBoardPart.titleAdjustment = null;
    this.ipBoardPart.otherTitleAdjustment = null;

    if (this.ipBoardPart.id != null) {
      this.initializeFromPreviousContent();
    }
    this.initializeSelectedOptions();

    this.addSubscription(
      this.emitValueChanged,
      () => {
        this.projectDisplayObservableService
          .getIPBoardConfigurationChangedSubscribable()
          .next();
      },
      () => {},
      500
    );
    this.addSubscription(
      this.projectDisplayObservableService.getResetLeftRightSubscribable(),
      (event: boolean) => {
        this.showOtherSidePicker = false;
        this.showOtherSidePickerChanged();
      }
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.emitValueChanged != null) {
      this.emitValueChanged.complete();
      this.emitValueChanged = null;
    }
  }

  private initializeFromPreviousContent(): void {
    if (this.ipBoardPart.previousTitleContent != null) {
      this.ipBoardPart.otherTitle = this.ipBoardPart.previousTitleContent;
    }
    if (this.ipBoardPart.previousOtherSideTitleContent != null) {
      this.ipBoardPart.otherSideOtherTitle =
        this.ipBoardPart.previousOtherSideTitleContent;
    }
    this.ipBoardPart.previousTitleContent = null;
    this.ipBoardPart.previousOtherSideTitleContent = null;
  }

  private initializeSelectedOptions(): void {
    this.selectedTitleOption = ProductHelper.getSelectedTitleOption(
      this.ipBoardPart.otherTitle
    );
    this.selectedOtherSideTitleOption = ProductHelper.getSelectedTitleOption(
      this.ipBoardPart.otherSideOtherTitle
    );
    if (!this.leftRightBoard) {
      this.showOtherSidePicker =
        this.ipBoardPart.otherTitle !== this.ipBoardPart.otherSideOtherTitle;
    }
  }

  showOtherSidePickerChanged(): void {
    if (!this.showOtherSidePicker) {
      this.selectedOtherSideTitleOption = this.selectedTitleOption;
      this.ipBoardPart.otherSideOtherTitle = this.ipBoardPart.otherTitle;
      this.emitValueChanged.next();
      this.save.emit();
    }
  }

  selectedTitleOptionChanged(): void {
    if (this.selectedTitleOption == null) {
      return;
    }
    this.ipBoardPart.otherTitle =
      this.selectedTitleOption.id === ProductHelper.OTHER_TITLE_ID
        ? null
        : this.selectedTitleOption.label;
    if (!this.showOtherSidePicker) {
      this.ipBoardPart.otherSideOtherTitle =
        this.selectedTitleOption.id === ProductHelper.OTHER_TITLE_ID
          ? null
          : this.selectedTitleOption.label;
    }
    this.emitValueChanged.next();
    this.save.emit();
  }

  otherTitleChanged(): void {
    if (!this.showOtherSidePicker) {
      this.ipBoardPart.otherSideOtherTitle = this.ipBoardPart.otherTitle;
    }
    this.emitValueChanged.next();
    this.save.emit();
  }

  selectedOtherSideTitleOptionChanged(): void {
    this.ipBoardPart.otherSideOtherTitle =
      this.selectedOtherSideTitleOption.id === ProductHelper.OTHER_TITLE_ID
        ? null
        : this.selectedOtherSideTitleOption.label;
    this.emitValueChanged.next();
    this.save.emit();
  }

  otherSideOtherTitleChanged(): void {
    this.emitValueChanged.next();
    this.save.emit();
  }

  compareOptions(o1: TitleOption, o2: TitleOption): boolean {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      return o1.id === o2.id;
    } else {
      return false;
    }
  }
}
